import { CircleAlert } from 'lucide-react';

import { Icon, withConfirmation } from '@crossnokaye/ux-common';

import { useRestartShutdown } from '@/hooks/query-hooks/gaia-api/shutdown-banner';
import { useCurrentFacility } from '@/hooks/use-current-facility';
import { Button } from '@/ux-common/components/button/button';

const ButtonWithConfirmation = withConfirmation(Button);

export const RestartBuildingAction = () => {
  const { agentId } = useCurrentFacility();
  const { mutate: restartShutdown } = useRestartShutdown({ agentId });
  const Title = (
    <div className={'flex items-center gap-4 text-foreground'}>
      <Icon
        data-testid={`restart-building-alert-icon`}
        icon={CircleAlert}
        backgroundColor={'bg-ckds-base-critical'}
        variant="rounded"
        size="md"
        color="text-foreground"
      />
      {'Are you sure you want to Restart your Building?'}
    </div>
  );
  return (
    <ButtonWithConfirmation
      confirmationDescription={
        'Restarting will significantly increase your monthly energy costs due to high rates, peak demand, and active cost-control measures.'
      }
      confirmationTitle={Title}
      confirmLabel={'Yes, Restart Building'}
      cancelLabel={'Do Not Restart Building'}
      confirmVariant={'destructive'}
      onConfirm={async () => {
        await restartShutdown({});
      }}
      className="btn btn-inverse"
    >
      {'Restart Building'}
    </ButtonWithConfirmation>
  );
};
